/**
 * Language Context
 */

import React, { createContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  
  // Normalize detected language (e.g. 'en-US' → 'en')
  const normalizeCode = (code) => (code || 'en').split('-')[0].toLowerCase();
  
  const [language, setLanguage] = useState(normalizeCode(i18n.language));

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
    document.documentElement.setAttribute('lang', lng);
  };

  useEffect(() => {
    document.documentElement.setAttribute('lang', language);
  }, [language]);

  const supportedLanguages = [
    { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
    { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', flag: '🇮🇳' },
    { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳' },
    { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી', flag: '🇮🇳' },
    { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
    { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  ];

  const currentLanguageInfo = supportedLanguages.find(l => l.code === language);

  return (
    <LanguageContext.Provider value={{ language, currentLanguage: language, changeLanguage, supportedLanguages, currentLanguageInfo }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
